import { render, staticRenderFns } from "./Trans.vue?vue&type=template&id=1427d2d4&scoped=true&"
import script from "./Trans.vue?vue&type=script&lang=js&"
export * from "./Trans.vue?vue&type=script&lang=js&"
import style0 from "./Trans.vue?vue&type=style&index=0&id=1427d2d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1427d2d4",
  null
  
)

export default component.exports